import { Injectable } from '@angular/core';
import { type Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs';
import { openGenericModal } from '@innogy/common-ui-modals';
import { mapGenericModalProperties } from '@legacy/common-ui-shared';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';

import { getOrderCustomerTypeState } from './order-customer-type.selector';
import {
  initOrderCustomerType,
  orderCustomerTypeEnabled,
  showCustomerTypeExplanation,
} from './order-customer-type.actions';

@Injectable()
export class OrderCustomerTypeEffects {
  constructor(
    private readonly store$: Store,
    private readonly actions$: Actions
  ) {}

  orderCustomerTypeState$ = this.store$.select(getOrderCustomerTypeState);

  public readonly enableCustomerTypeAfterInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initOrderCustomerType),
      withLatestFrom(this.orderCustomerTypeState$),
      switchMap(([_, { enabled }]) => {
        const actions: Action[] = [
          // Notify other modules that customer type has been enabled
          orderCustomerTypeEnabled({ enabled }),
        ];

        return actions;
      })
    )
  );

  public readonly openInformation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(showCustomerTypeExplanation),
      map(({ payload }) =>
        openGenericModal(
          mapGenericModalProperties(
            GenericModalSources.CUSTOMER_TYPE_EXPLANATION_MODAL,
            {
              Title: { value: payload.customerTypeModalTitle },
              Body: { value: payload.customerTypeModalBody.value as string },
              PrimaryButtonText: {
                value: payload.customerTypeModalButtonText,
              },
              PrimaryButtonStyle: { value: 'primary' },
            }
          )
        )
      )
    )
  );
}
